import React from 'react';
import CookietractorInformationBlock from 'libs/sanity/content/Blocks/CookietractorInformationBlock';

const CookietractorInformationModule = () => <CookietractorInformationBlock />;

export default CookietractorInformationModule;
